import type { FC } from 'react'
import { Box } from '@chakra-ui/react'
import tryggehandel from '#/src/images/tryggehandel.webp'
import appConfig from '#/src/appConfig'
import { GrandImage } from 'ui'
import { FooterStandard, type FooterStandardProps } from 'storefront-modules/layout/footer'

type IFooter = Pick<FooterStandardProps, 'footerItems' | 'logo' | 'socialMediaItems'>

const CustomFooter: FC<IFooter> = ({ logo, footerItems, socialMediaItems }) => {
  return (
    <FooterStandard
      logo={logo}
      footerItems={footerItems}
      socialMediaItems={socialMediaItems}
      paymentProviderName={appConfig.paymentProviderConfig?.providerName}
      maxColumns={appConfig.footerConfig?.maxColumns}
      socialMediasAfterAddon={
        <Box>
          <GrandImage alt="Tryggehandel" height={95} src={tryggehandel} width={95} />
        </Box>
      }
    />
  )
}

export default CustomFooter
